import { Storage, StorageSetItemOptions } from '../index';
import globalWindow from '@shared/core/globals';

const document = globalWindow.document;
// Secure flag: Only set on HTTPS to prevent cookies from being sent over insecure connections
// Omitted on HTTP (localhost/dev) so cookies work in local development
const secureInCookie = globalWindow.location?.protocol === 'https' ? 'Secure;' : '';
export const COOKIE_PREFIX_KEY = 'joy';

/**
 * Cookie based key value pair storage.
 * When storing the cookies we will prefix 'joy' to the key and URICompoenent encode the value
 * The key is modified for easy debugging so that all cookies will start with Joy.
 * The value is modified because we dont want = and ; get into it otherwise it might mess up our parsing
 * @constructor
 */
export class CookieStorage implements Storage {
  public getItem(key: string) {
    const pair = document?.cookie
      .split(';')
      .map(c => {
        return c.split('=');
      })
      .map(pair1 => {
        pair1[0] = pair1[0].trim();
        return pair1;
      })
      .find(pair2 => {
        return pair2[0] === COOKIE_PREFIX_KEY + key;
      });

    if (!pair) {
      return null;
    }

    return global.decodeURIComponent(pair[1]);
  }

  public setItem(key: string, value: string | null | undefined, options?: StorageSetItemOptions) {
    const keyInCookie = COOKIE_PREFIX_KEY + key;
    const valueIsNullOrUndefined = value === undefined || value === null;
    const valueInCookie = valueIsNullOrUndefined ? '' : global.encodeURIComponent(value as string);

    // Delete cookie by setting expiration to past date (Jan 1, 1970)
    let expInCookie = '';
    if (valueIsNullOrUndefined) {
      expInCookie = 'expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    } else if (options?.maxAgeInSeconds !== undefined) {
      expInCookie = `max-age=${options.maxAgeInSeconds};`;
    }

    // Cookie flags:
    // - path=/: Cookie available to all routes in the domain
    // - Secure: Cookie only transmitted over HTTPS (skipped in dev/localhost)
    // - SameSite=Lax: CSRF protection while allowing top-level GET navigations
    //   Blocks cross-site POST/iframe but allows cookies on inbound links (email, social)
    //   Critical for SSR: Users clicking links from external sites need auth cookies
    const cookie = `${keyInCookie}=${valueInCookie};${expInCookie}path=/;${secureInCookie}SameSite=Lax;`;

    if (document) {
      document.cookie = cookie;
    }
  }
}
